/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
var nebula = (function (options) {
    var success = options.success, fail = options.fail, _a = options.overtime, overtime = _a === void 0 ? 3000 : _a;
    document.addEventListener('AlipayJSBridgeReady', function () {
        return success({
            data: window.AlipayJSBridge,
        });
    }, false);
    // 超时阈值设置，3s暂时根据经验
    setTimeout(function () {
        return fail({
            errMsg: 'jsbridgeReady API is timeout',
        });
    }, overtime);
});

export { nebula as default };
